import type { ClientContext } from '~/services/contextClient';
import CorporateMembershipStatusDefinitionsClient from './corporateMembershipStatusDefinitionsClient';
import type { MembershipStatusDefinitionsClientInterface } from './membershipStatusDefinitionsClient.types';

export default class MembershipStatusDefinitionsClientFactory {
    static createClient(context: ClientContext): MembershipStatusDefinitionsClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateMembershipStatusDefinitionsClient(context.teamId);
        }

        throw new Error('Membership status definitions are only available at corporate level');
    }
}
